import { Route } from '@angular/router';
import { IsBuyerGuard, noAccessClassicGuard } from '../../../../auth/routing/guards';
import { SuppliersComponent } from '../../../pages/suppliers';
import { SupplierCreateRoutingComponent } from '../../../pages/suppliers/supplier-create-routing.component';
import { SuppliersResolver, SuppliersTabsResolver } from '../../resolvers';

export const SuppliersRoutes: Route = {
    path: 'contacts',
    component: SuppliersComponent,
    resolve: {
        suppliers: SuppliersResolver,
        availableTabs: SuppliersTabsResolver,
    },
    canActivate: [noAccessClassicGuard, IsBuyerGuard],
    children: [
        {
            path: 'new',
            component: SupplierCreateRoutingComponent
        }
    ]
};
